export function normalizeDamageCounts(
  damageReport,
  packages,
  pallets,
  totalPackages = 0,
  totalPallets = 0
) {
  if (damageReport !== "Ja") {
    return { valid: true, damagedPackages: 0, damagedPallets: 0 };
  }

  const damagedPackages = Number(packages || 0);
  const damagedPallets = Number(pallets || 0);

  if (
    !Number.isInteger(damagedPackages) ||
    damagedPackages < 0 ||
    !Number.isInteger(damagedPallets) ||
    damagedPallets < 0
  ) {
    return {
      valid: false,
      message: "Beschädigte Pakete und Paletten müssen ganze Zahlen ab 0 sein.",
    };
  }

  if (damagedPackages === 0 && damagedPallets === 0) {
    return {
      valid: false,
      message: "Bitte gib mindestens ein beschädigtes Paket oder eine beschädigte Palette an.",
    };
  }

  if (Number(totalPackages) > 0 && damagedPackages > Number(totalPackages)) {
    return {
      valid: false,
      message: "Die Anzahl beschädigter Pakete darf nicht größer als die Gesamtanzahl der Pakete sein.",
    };
  }

  if (Number(totalPallets) > 0 && damagedPallets > Number(totalPallets)) {
    return {
      valid: false,
      message: "Die Anzahl beschädigter Paletten darf nicht größer als die Gesamtanzahl der Paletten sein.",
    };
  }

  return { valid: true, damagedPackages, damagedPallets };
}

export function createAutomaticDamageEffort(recordPayload, username) {
  return {
    timestamp: new Date().toLocaleString("de-DE"),
    customer: recordPayload.selectedSupplier,
    effortType: "Schadensprotokoll",
    customEffort: "",
    comment: `${recordPayload.type}: Schaden`,
    durationMinutes: 10,
    expenseType: "",
    expenseAmount: 0,
    processDurationSeconds: 0,
    employee: username || "",
    damagedPackages: Number(recordPayload.damagedPackages) || 0,
    damagedPallets: Number(recordPayload.damagedPallets) || 0,
    photoData: "",
    photoDataList: [],
  };
}
